module.exports = __webpack_public_path__ + "img/Project Manager.8f9c233b.png";